import { defineModule } from '@portal/kernel';

export const manifest = defineModule({
  key: 'calendar',
  version: '0.1.0',
  kind: 'business',
  coreVersion: '^0.1.0',
  name: { vi: 'Lịch', en: 'Calendar' },
  description: {
    vi: 'Lịch họp, mời họp và phản hồi, đặt phòng họp, nhắc giờ.',
    en: 'Meetings, invitations and answers, meeting rooms, reminders.',
  },
  dependsOn: ['core-system', 'core-audit', 'core-identity', 'core-access', 'core-notification'],
  database: { schema: 'calendar' },
  permissions: [
    {
      key: 'calendar.event.use',
      name: { vi: 'Dùng lịch (tạo họp, đặt phòng)', en: 'Use the calendar' },
      defaultGranted: true,
    },
    {
      key: 'calendar.room.manage',
      name: { vi: 'Quản lý phòng họp', en: 'Manage meeting rooms' },
    },
  ],
  navigation: [
    {
      id: 'calendar',
      label: { vi: 'Lịch', en: 'Calendar' },
      icon: 'calendar',
      order: 46,
      children: [
        {
          id: 'calendar.mine',
          label: { vi: 'Lịch của tôi', en: 'My calendar' },
          icon: 'calendar',
          path: '/calendar',
          permission: 'calendar.event.use',
          order: 1,
        },
        {
          id: 'calendar.rooms',
          label: { vi: 'Phòng họp', en: 'Meeting rooms' },
          icon: 'building',
          path: '/calendar/rooms',
          permission: 'calendar.event.use',
          order: 2,
        },
      ],
    },
  ],
  notifications: [
    {
      key: 'calendar.invited',
      name: { vi: 'Được mời họp', en: 'Meeting invitation' },
      defaultChannels: ['in_app', 'email'],
    },
    {
      key: 'calendar.changed',
      name: { vi: 'Cuộc họp đổi giờ, đổi phòng hoặc bị huỷ', en: 'Meeting changed or cancelled' },
      defaultChannels: ['in_app', 'email'],
    },
    {
      key: 'calendar.reminder',
      name: { vi: 'Nhắc giờ họp', en: 'Meeting reminder' },
      defaultChannels: ['in_app'],
    },
    {
      key: 'calendar.response',
      name: { vi: 'Phản hồi lời mời họp của tôi', en: 'Answers to my invitations' },
      defaultChannels: ['in_app'],
    },
  ],
  roleTemplates: [
    {
      key: 'rooms',
      name: { vi: 'Quản lý phòng họp', en: 'Meeting room manager' },
      description: { vi: 'Hành chính: khai báo và sửa phòng họp.' },
      grants: [{ permission: 'calendar.room.manage' }],
    },
  ],
  widgets: [
    {
      key: 'calendar.today',
      title: { vi: 'Lịch hôm nay', en: "Today's meetings" },
      permission: 'calendar.event.use',
      order: 3,
    },
  ],
});
